import { AiOutlineSearch } from "solid-icons/ai";
import { type Accessor, type Component, Show } from "solid-js";
import { useI18n } from "@/api/i18n";
import { JobOfferBadges } from "@/components/shared/jobs/job-offer-badges";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { JobOfferV2WithCompanyId } from "@/domains/job-offer/types";
import { cn } from "@/libs/cn";

interface SearchOfferCardProps {
  job: JobOfferV2WithCompanyId;
  isInactive: Accessor<boolean>;
  onClick?: () => void;
}

export const SearchOfferCard: Component<SearchOfferCardProps> = (props) => {
  const isInactive = props.isInactive;
  const { t } = useI18n();
  return (
    <Card
      class={cn(
        "border border-gray-200 shadow-sm max-w-full bg-white rounded-lg w-full relative cursor-pointer transition-shadow duration-200 hover:shadow-md",
        !isInactive() && "border-primary border-2 shadow-md",
      )}
      onClick={props.onClick}
    >
      <CardHeader class="pb-3">
        <div class="flex items-start justify-between gap-4">
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <CardTitle
              class={cn(
                "text-lg font-bold text-black",
                isInactive() && "text-muted-foreground",
              )}
            >
              {props.job.title}{" "}
              <Show when={!isInactive()}>
                <Badge variant="warning" size="sm" class="ml-2">
                  {t("company.search.freelancers.offers.lastSearch")}
                </Badge>
              </Show>
            </CardTitle>
          </div>
          <div class="shrink-0">
            <AiOutlineSearch
              size={20}
              class={cn("text-gray-400", !isInactive() && "text-primary")}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent class="pt-0 space-y-3">
        <JobOfferBadges job={props.job} isInactive={isInactive} maxSkills={3} />
      </CardContent>
    </Card>
  );
};
